import { Spinner } from "shared/ui/spinners/spinner";

const CenterFixedLoading = () => (
  <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
    <Spinner />
  </div>
);

export default CenterFixedLoading;
